export default "__VITE_ASSET__7k9tEwqb__"